// @flow
import type { Action } from '../actions/listings';

export type Listing = Object;

export type State = {
  byId: {
    [string]: {
      ...Listing,
      isFetching: boolean
    }
  }
};

export default function listings(state: State = { byId: {} }, action: Action) {
  switch (action.type) {
    case 'FETCH_LISTING_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listingId]: {
            ...state.byId[action.listingId],
            id: action.listingId,
            isFetching: true
          }
        }
      };
    case 'FETCH_LISTING_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listing.id]: {
            ...action.listing,
            isFetching: false
          }
        }
      };
    case 'FETCH_IMPORTED_LISTING_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listing.objectID]: {
            ...action.listing,
            id: action.listing.objectID,
            isFetching: false
          }
        }
      };
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
